// src/auth.js
import axios from 'axios';
import { API_BASE_URL } from './config';

const TOKEN_KEY   = 'token';
const EXPIRES_KEY = 'expiresAt';

//
// Token storage
//
export function setToken(token, expiresInSeconds) {
  const expiresAt = Date.now() + expiresInSeconds * 1000;
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_KEY, expiresAt.toString());
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function isTokenExpired() {
  const exp = localStorage.getItem(EXPIRES_KEY);
  if (!exp) return true;
  return Date.now() > parseInt(exp, 10);
}

export function isLoggedIn() {
  const token = getToken();
  return !!token && !isTokenExpired();
}

export function getAuthHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

//
// Login
//
// src/auth.js
export async function login({ username, password }) {
  // clear any old token
  clearToken();

  const url = `${API_BASE_URL}/auth/login`;
  console.log('➡️  [auth.js] POST', url, { username, password });

  try {
    const res = await axios.post(
      url,
      { username, password },
      { headers: { 'Content-Type': 'application/json' } }
    );

    console.log('⬅️  [auth.js] HTTP', res.status, res.statusText);
    console.log('⬅️  [auth.js] DATA', res.data);

    const data = res.data || {};

    // if the server sent { error,… } bail early
    if (data.error) {
      const msg = data.error_description || data.error;
      throw new Error(msg);
    }

    // try both snake_case and camelCase just in case
    const token     = data.access_token || data.accessToken || data.token;
    const expiresIn = data.expires_in   || data.expiresIn;

    if (!token || !expiresIn) {
      throw new Error(
        `Login response missing token/expires_in! got: ` +
        JSON.stringify(data)
      );
    }

    // store it
    setToken(token, expiresIn);
    console.log('✅ [auth.js] stored token, expires in', expiresIn, 'seconds');

  } catch (err) {
    // normalize axios “throw” vs our manual throw
    const msg =
      err.response?.data?.error_description ||
      err.response?.data?.error ||
      err.message;
    console.error(' [auth.js] login failed:', msg);
    throw new Error(msg);
  }
}

// your existing helpers must remain:
// setToken, clearToken, getToken, isTokenExpired, isLoggedIn, getAuthHeader, logout…

//
// Logout
//
export function logout() {
  clearToken();
  // redirect back to your login route
  window.location.href = '/auth/login';
}
